/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Comment-mark': {
    width: 11,
    height: 11,
    viewBox: '0 0 11 11',
    data: '<g fill-rule="nonzero" _fill="none"><path pid="0" d="M.473.206v9.849h9.848V.206H.473zM8.806 8.54H1.988V1.722h6.818V8.54z" _fill="#EBEBEB"/><path pid="1" _fill="#E9523B" d="M3.503 3.237H7.29v3.788H3.503z"/></g>'
  }
})
